export default {
    siteKey: "6LeIbcIeAAAAABCteU_DMGcHOQFi1PvgDMF1Rk5d",
}